<template>
  <div id="core" v-loading="store.settings.loading">
    <el-menu :default-active="store.settings.activeIndex" @select="handleSelect" mode="horizontal" background-color="#324157" text-color="#dddddd" active-text-color="white" class="hidden-xs-only">
      <el-menu-item style="padding-top: 5px; padding-right: 8vw; pointer-events: none;" index="0">
        <div>
          <img src="./assets/MSDB_logo.png" alt="MSDB Logo">
        </div>
      </el-menu-item>
      <el-menu-item index="1">
        Home
      </el-menu-item>
      <el-menu-item index="2">
        Browse
      </el-menu-item>
      <el-menu-item index="3">
        Download
      </el-menu-item>
      <el-menu-item index="4">
        Help
      </el-menu-item>
    </el-menu>
    <el-collapse class="hidden-sm-and-up" id='core-nav-collapse'>
      <el-collapse-item id="nav-menu">
        <template slot="title">
          <div style="width: 100%">
            <el-row style="padding-top: 20px">
              <el-col :span="24">
                <img height="100%" width="auto" src="./assets/MSDB_logo.png" alt="MSDB Logo">
                <i style="font-size: 1.4em; float: right; padding-top: 10px; padding-right: 10px;" class="fas fa-icon-bars"></i>
              </el-col>
            </el-row> 
          </div>
        </template>
        <el-menu :default-active="store.settings.activeIndex" @select="handleSelect" mode="vertical" background-color="#324157" text-color="#dddddd" active-text-color="white">
          <el-menu-item class="nav-menuitem" index="1">
            Home
          </el-menu-item>
          <el-menu-item class="nav-menuitem" index="2">
            Browse
          </el-menu-item>
          <el-menu-item class="nav-menuitem" index="3">
            Download
          </el-menu-item>
          <el-menu-item class="nav-menuitem" index="4">
            Help
          </el-menu-item>
        </el-menu>
      </el-collapse-item>
    </el-collapse>
    <home v-if="store.settings.activeIndex === '1'"></home>
    <browse v-if="store.settings.activeIndex === '2'"></browse>
    <download v-if="store.settings.activeIndex === '3'"></download>
    <help v-if="store.settings.activeIndex === '4'"></help>
  </div>
</template>

<script>
import { store } from './scripts/store.js'
import 'element-ui/lib/theme-chalk/display.css';

import Vue from 'vue'
import Home from './views/home.vue'
import Browse from './views/browse.vue'
import Download from './views/download.vue'
import Help from './views/help.vue'

const d3 = require('d3')

export default {
  name: 'core',
  components: {
    Home, Browse, Download, Help
  },
  data () {
    return {
      store: store
    }
  },
  mounted () {
    this.loadSpecies()
  },
  methods: {
    handleSelect (index) {
      this.store.settings.activeIndex = index
    },
    loadSpecies () {
      d3.tsv('./data/MSDB_GenomesTable.tsv').then(data => {
        store.species.list = data
        store.species.list.map(x => Vue.set(x, 'show', true))
        store.species.list.map(x => {
          x.MSDBID === store.species.initialSelection ? Vue.set(x, 'selected', true) : Vue.set(x, 'selected', false)
          x.Size = parseFloat(x.Size)
          x.GC = parseFloat(x.GC)
        })
        store.sortSpeciesList('Initial Caller')
        store.species.current = store.species.initialSelection
        d3.json(`data/info/${store.species.initialSelection}_info.json`).then(data => store.info.push(data.info))
      })
    },
    // navmenuCallback (index) {
    //   d3.select('#nav-menu').classed('is-active', false);
    //   d3.select('#nav-menu > div > .el-collapse-item__header').classed('is-active', false);
    //   this.store.settings.activeIndex = index;
    // }
  }
}
</script>

<style>
#core {
  font-family: 'Ubuntu', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

li.el-menu-item {
  font-size: 1.1em;
}

li.el-menu-item.is-active {
  font-weight: bold
}

#browse-collapse .el-collapse-item {
  border-bottom: 2px solid #dcdcdc;
  padding-left: 0px;
  /* box-shadow: 0px 3px 10px 0px #dcdcdc; */
  border-radius: 3px;
}


#core-nav-collapse > .el-collapse-item__header {
  background-color: "#324157" !important; 
  height: 8vh !important;
}

/* This is for the header of species selection pane */
#core-nav-collapse > .el-collapse-item > div > div[role="button"] {
  background-color: #324157;
  /* color: #324157; */
  padding: 10px;
  color: white;
  font-size: 1.2em;
  font-weight: bold;
}

#core-nav-collapse > .el-collapse-item > div > div[role="button"] > i {
  display: none !important;
}

#core-nav-collapse div.el-collapse-item .fas {
  color: white
}

#core-nav-collapse div.el-collapse-item.is-active .fas {
  color: #66B1FE;
}

.el-popper, .el-tooltip__popper, .el-message {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
}

.el-card {
  border: none !important;
}
</style>

<style lang="scss">
$fa-css-prefix: 'fa-icon';
$fa-font-path: '~@fortawesome/fontawesome-free/webfonts';

@import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
@import '~@fortawesome/fontawesome-free/scss/solid.scss';
@import '~@fortawesome/fontawesome-free/scss/brands.scss';

[class^='#{$fa-css-prefix}-'], [class*=' #{$fa-css-prefix}-'] {
  font-family: 'Font Awesome 5 Free' !important; // override ElementUI's icon font
}

.fas {
  font-family: 'Font Awesome 5 Free' !important;
}
</style>

